<!--
  titleIcon 的 preferWebp 只能在這種靜態相對路徑的呼叫端套用，
  不可搬進 swiper-unit 的 [src]="titleIcon" —— 該綁定同時服務 home.component
  傳入的動態 item?.icon，而 pipe 以 `.` 切字串取 arr[0]，遇到含多個點的網址
  （如 https://cdn.example.com/x.png）會產出 https://cdn.webp 而整個壞掉。
  另需確保對應的 .webp 確實存在，否則支援 webp 的瀏覽器會拿到 404。
-->
<app-swiper-unit
  [data]="providerList"
  title="Providers"
  [titleIcon]="'assets/images/home/bear_taps.png' | preferWebp"
  [isProvider]="true"
  [hasFavorite]="false"
  [hasHover]="false"
  [hasMask]="false"
  [ratio]="1 / 0.34"
  [titleHref]="'/' + providerHref"
  [imgCarouselConfig]="imgCarouselConfig"
  (clickItem)="clickProviderItem($event)"
  (clickTitle)="clickProviderTitle()"
  [showArrowGroupH5]="true"
></app-swiper-unit>
